
import { motion } from 'framer-motion';

export default function Features() {
  const features = [
    {
      title: 'Gamified Learning Missions',
      badge: 'Learning',
      image: 'https://public.readdy.ai/ai/img_res/3c39c494852794c277eecd7d5c5b8182.jpg',
    },
    {
      title: 'Real-Time Analytics Dashboard',
      badge: 'Tracking',
      image: 'https://readdy.ai/api/search-image?query=modern%20analytics%20dashboard%20interface%20on%20computer%20screen%20showing%20colorful%20charts%20and%20metrics%2C%20professional%20data%20visualization%20with%20clean%20design%2C%20warm%20ambient%20lighting%2C%20business%20intelligence%20concept%20with%20simple%20background%2C%20contemporary%20workspace%20aesthetic&width=600&height=400&seq=dashboard-feature-001&orientation=landscape',
    },
    {
      title: 'Exclusive Partner Rewards',
      badge: 'Rewards',
      image: 'https://readdy.ai/api/search-image?query=premium%20merchandise%20and%20gift%20boxes%20beautifully%20arranged%2C%20professional%20product%20photography%20with%20soft%20lighting%2C%20exclusive%20rewards%20and%20branded%20apparel%20showcase%2C%20clean%20minimalist%20background%2C%20luxury%20lifestyle%20aesthetic%20with%20warm%20tones&width=600&height=400&seq=rewards-feature-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="text-sm font-light text-gray-500 tracking-wide mb-3 uppercase">
              Platform Features
            </div>
            <h2 className="text-5xl font-serif italic text-charcoal-800 leading-tight">
              Everything You Need to Succeed
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex items-center"
          >
            <p className="text-gray-600 leading-relaxed">
              HoneyJar provides a comprehensive ecosystem for learning, earning, and redeeming rewards. Our platform combines cutting-edge gamification with seamless e-commerce integration to create an unparalleled user experience.
            </p>
          </motion.div>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              whileHover={{ y: -8 }}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="inline-block mb-3">
                    <span className="px-3 py-1 bg-accent text-charcoal-800 text-xs font-bold rounded-full uppercase">
                      {feature.badge}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-charcoal-800 leading-tight">
                    {feature.title}
                  </h3>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
